import React, { useState } from "react";
import '../css/App.css';
import '../css/books.css';
import AboutBookSection from '../Components/AboutBookSection';

import conductor from "../images/carousel-images/The Conductor - Cover - gold medal - small.jpg";
import pharaoh from "../images/carousel-images/pharaoh-cover-small2.png";
import RITH from "../images/carousel-images/RITH_small1.jpg";
import UTWS from "../images/carousel-images/UTWOS_small1.jpg";
import DA from "../images/carousel-images/da_fixed1.png";
import PD from "../images/carousel-images/PD_small1.jpg";
import WH from "../images/carousel-images/wizards-heir.jpg";
import HW from "../images/carousel-images/heavens-warrior.jpg";
import BlackJackImg from '../images/carousel-images/blackjack-medallion-small-2.png';
import MortimerImg from '../images/carousel-images/mortimer-medallion-small-2.png';
import LongTomImg from '../images/carousel-images/longtom-small.jpg';



export default class Books extends React.Component {
  constructor(props) {
    super(props);
    this.state = {shownBook: ''};  }


  render () {
    return(
    <div className="books-page">

      <div class="text-divider">Select A Book</div>

      <div className="books-list">
        <ul>
          <li>
            <div className="book-cover" id="blackjack" onClick={ ()=> {
              this.setState({shownBook:"blackjack"});
            } }>
              <figure>
                <img src={BlackJackImg} />
                <figcaption>Black Jack: Behind the Waves</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="mortimer" onClick={ ()=> {
              this.setState({shownBook:"mortimer"});
            } }>
              <figure>
                <img src={MortimerImg} />
                <figcaption>Mortimer: Behind the Walls</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="longtom" onClick={ ()=> {
              this.setState({shownBook:"longtom"});
            } }>
              <figure>
                <img src={LongTomImg} />
                <figcaption>Long Tom: Behind the Woods</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="conductor" onClick={ ()=> {
              this.setState({shownBook:"conductor"});
            } }>
              <figure>
                <img src={conductor} />
                <figcaption>The Conductor</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="pharaoh" onClick={ ()=> {
              this.setState({shownBook:"pharaoh"});
            } }>
              <figure>
                <img src={pharaoh} />
                <figcaption>Pharaoh's Mountain</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="rage" onClick={ ()=> {
              this.setState({shownBook:"rage"});
            } }>
              <figure>
                <img src={RITH} />
                <figcaption>A Rage in the Heavens</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="upon" onClick={ ()=> {
              this.setState({shownBook:"upon"});
            } }>
              <figure>
                <img src={UTWS} />
                <figcaption>Upon This World of Stone</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="darknesss" onClick={ ()=> {
              this.setState({shownBook:"darknesss"});
            } }>
              <figure>
                <img src={DA} />
                <figcaption>Darkness Ascending</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="daughter" onClick={ ()=> {
              this.setState({shownBook:"daughter"});
            } }>
              <figure>
                <img src={PD} />
                <figcaption>Paladin's Daughter</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="heir" onClick={ ()=> {
              this.setState({shownBook:"heir"});
            } }>
              <figure>
                <img src={WH} />
                <figcaption>Wizard's Heir</figcaption>
              </figure>
            </div>
          </li>
          <li>
            <div className="book-cover" id="warrior" onClick={ ()=> {
              this.setState({shownBook:"warrior"});
            } }>
              <figure>
                <img src={HW} />
                <figcaption>Heaven's Warrior</figcaption>
              </figure>
            </div>
          </li>
        </ul>
      </div>

      <div className="books-about">
        <AboutBookSection shownBook={this.state.shownBook}/>
      </div>

        

  </div>
  )}
}
